/**
 * Resuelve la entidad Banda asociada a un User (titular o colaborador delegado).
 * El API debe incluir `banda` y `bandaColaborador.banda` en solicitante/confirmador.
 */
export function resolveBandaFromUser(user) {
  if (!user) return null;
  if (user.banda) return user.banda;
  if (user.bandaColaborador?.banda) return user.bandaColaborador.banda;
  return null;
}

export function resolveCofradiaFromUser(user) {
  if (!user?.cofradia) return null;
  return user.cofradia;
}
